import React from "react";
import AttOnly from "../../img/AttOnlyInd.png";
import ZombieKiller from "../../img/ZombieKillerInd.png";
// import AreaAtt from "../../img/AreaAttInd.png";
// import AttBuff from "../../img/AttBuffInd.png";
import BarrierBreaker from "../../img/BarrierBreakerInd.png";
import BaseDest from "../../img/BaseInd.png";
// import CostDown from "../../img/CostDownInd.png";
import Critical from "../../img/CriticalInd.png";
// import DefBuff from "../../img/DefBuffInd.png";
import ExtraMoney from "../../img/ExtraMoneyInd.png";
import Freeze from "../../img/FreezeInd.png";
// import ImpKnockback from "../../img/ImpKnockbackInd.png";
import InsaneDmg from "../../img/InsaneDmgInd.png";
import InsanelyTough from "../../img/InsanelyToughInd.png";
import Knockback from "../../img/KnockbackInd.png";
import SurgeAttacks from "../../img/SurgeAttInd.png";
// import LessEffCurse from "../../img/LessEffCurseInd.png";
// import LessEffFreeze from "../../img/LessEffFreezeInd.png";
// import LessEffKnockback from "../../img/LessEffKnockbackInd.png";
// import LessEffResist from "../../img/LessEffResistInd.png";
// import LessEffSlow from "../../img/LessEffSlowInd.png";
// import LessEffWarp from "../../img/LessEffWarpInd.png";
// import LessEffWave from "../../img/LessEffWaveInd.png";
import LongDist from "../../img/LongDistInd.png";
import MassiveDmg from "../../img/MassiveDmgInd.png";
import Metal from "../../img/MetalInd.png";
import Multihit from "../../img/MultiHitInd.png";
// import MoveSpdUp from "../../img/MoveSpdUpInd.png";
import Omnistrike from "../../img/OmniStrikeInd.png";
// import RecoverSpdUp from "../../img/RecoverSpdUpInd.png";
import Resistant from "../../img/ResistantInd.png";
import ResistCurse from "../../img/ResistCurseInd.png";
import ResistFreeze from "../../img/ResistFreezeInd.png";
import ResistKnockback from "../../img/ResistKnockbackInd.png";
import ResistSlow from "../../img/ResistSlowInd.png";
import ResistWarp from "../../img/ResistWarpInd.png";
import ResistWeaken from "../../img/ResistWeakenInd.png";
// import SingleAtt from "../../img/SingleAttInd.png";
import Slow from "../../img/SlowInd.png";
import Strengthen from "../../img/StrengthenInd.png";
import StrongAgainst from "../../img/StrongAgainstInd.png";
import Survive from "../../img/SurviveInd.png";
import UnharmedWaves from "../../img/UnharmWavesInd.png";
// import Warp from "../../img/WarpInd.png";
import WaveAtt from "../../img/WaveAttInd.png";
import WaveShield from "../../img/WaveShieldInd.png";
import Weaken from "../../img/WeakenInd.png";
import Dodge from "../../img/DodgeInd.png";
import Curse from "../../img/CurseInd.png";
import SavageBlow from "../../img/SavageBlowInd.png";
import MiniWave from "../../img/MiniWaveInd.png";
import ApostleKiller from "../../img/ApostleKillerInd.png";
import EvadeSurge from "../../img/EvadeSurgeInd.png";
import ShieldPiercing from "../../img/ShieldPiercingInd.png";
import ColossusSlayer from "../../img/ColossusSlayerInd.png";
import BehemothSlayer from "../../img/BehemothSlayerInd.png";

const abilitylist = [
  {
    text: "엄청 강하다",
    valueEng: "Strong",
    value: "엄청 강하다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={StrongAgainst}
        alt="엄청 강하다"
        placeholder="엄청 강하다"
      />
    ),
  },
  {
    text: "멧집이 좋다",
    valueEng: "Resistant",
    value: "멧집이 좋다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Resistant}
        placeholder="멧집이 좋다"
        alt="멧집이 좋다"
      />
    ),
  },
  {
    text: "초맷집이 좋다",
    valueEng: "Insanely Tough",
    value: "초맷집이 좋다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={InsanelyTough}
        placeholder="멧집이 좋다"
        alt="멧집이 좋다"
      />
    ),
  },
  {
    text: "초데미지",
    valueEng: "Massive Damage",
    value: "초데미지",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={MassiveDmg}
        placeholder="초데미지"
        alt="초데미지"
      />
    ),
  },
  {
    text: "극데미지",
    valueEng: "Insane Damage",
    value: "극데미지",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={InsaneDmg}
        placeholder="극데미지"
        alt="극데미지"
      />
    ),
  },
  {
    text: "원거리 공격",
    valueEng: "Long Distance",
    value: "원거리 공격",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={LongDist}
        placeholder="원거리 공격"
        alt="원거리 공격"
      />
    ),
  },
  {
    text: "느리게 한다",
    valueEng: "to slow",
    value: "(?!.*영향을 받지 않음u2:.*느리게)^.*느리게 한다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Slow}
        placeholder="느리게 한다"
        alt="느리게 한다"
      />
    ),
  },
  {
    text: "날려버린다",
    valueEng: "of knockback",
    value: "(?!.*영향을 받지 않음u2:.*밀치기)^.*날려버린다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Knockback}
        placeholder="날려버린다"
        alt="날려버린다"
      />
    ),
  },
  {
    text: "멈춘다",
    valueEng: "to freeze",
    value: "(?!.*영향을 받지 않음u2:.*멈춘다)^.*멈춘다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Freeze}
        placeholder="멈춘다"
        alt="멈춘다"
      />
    ),
  },
  {
    text: "공격력 다운",
    valueEng: "to weaken",
    value: "(?!.*영향을 받지 않음u2:.*공다)^.*공격력 다운",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Weaken}
        placeholder="공격력 다운"
        alt="공격력 다운"
      />
    ),
  },
  {
    text: "살아남는다",
    valueEng: "Survive",
    value: "살아남는다",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Survive}
        placeholder="살아남는다"
        alt="살아남는다"
      />
    ),
  },
  {
    text: "메탈",
    valueEng: "Only takes 1",
    value: "제외하고 1만 받음",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Metal}
        placeholder="메탈"
        alt="메탈"
      />
    ),
  },
  {
    text: "성 파괴가 특기",
    valueEng: "Base Destroyer",
    value: "성 파괴가 특기",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BaseDest}
        placeholder="성 파괴가 특기"
        alt="성 파괴가 특기"
      />
    ),
  },
  {
    text: "격파시 머니 UP",
    valueEng: "money gained",
    value: "격파시 머니 UP",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ExtraMoney}
        placeholder="격파시 머니 UP"
        alt="격파시 머니 UP"
      />
    ),
  },
  {
    text: "크리티컬",
    valueEng: "Critical",
    value: "크리티컬.[^히트를]",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Critical}
        placeholder="크리티컬"
        alt="크리티컬"
      />
    ),
  },
  {
    text: "좀비 킬러",
    valueEng: "Zombie Killer",
    value: "좀비 킬러",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ZombieKiller}
        placeholder="좀비 킬러"
        alt="좀비 킬러"
      />
    ),
  },
  {
    text: "전방위 공격",
    valueEng: "Omni Strike",
    value: "전방위 공격",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Omnistrike}
        placeholder="전방위 공격"
        alt="전방위 공격"
      />
    ),
  },
  {
    text: "파동 공격",
    valueEng: "Wave attack",
    value: "파동 공격",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={WaveAtt}
        placeholder="파동 공격"
        alt="파동 공격"
      />
    ),
  },
  {
    text: "파동 스톱퍼",
    valueEng: "Wave Shield",
    value: "파동 스톱퍼",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={WaveShield}
        placeholder="파동 스톱퍼"
        alt="파동 스톱퍼"
      />
    ),
  },
  {
    text: "타겟 한정",
    valueEng: "Attacks only",
    value: "타겟 한정",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={AttOnly}
        placeholder="타겟 한정"
        alt="타겟 한정"
      />
    ),
  },

  {
    text: "공격력 업",
    valueEng: "Strengthen",
    value: "공격력 업",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Strengthen}
        placeholder="공격력 업"
        alt="공격력 업"
      />
    ),
  },
  {
    text: "다중 공격",
    valueEng: "Multi-hit",
    value: "다중 공격",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Multihit}
        placeholder="다중 공격"
        alt="다중 공격"
      />
    ),
  },

  {
    text: "멈춘다 내성",
    valueEng: "Not(.*Freeze)",
    value: "영향을 받지(.*멈춘다)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistFreeze}
        placeholder="멈춘다 내성"
        alt="멈춘다 내성"
      />
    ),
  },
  {
    text: "느리게 내성",
    valueEng: "Not(.*Slow)",
    value: "영향을 받지(.*느리게)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistSlow}
        placeholder="느리게 내성"
        alt="느리게 내성"
      />
    ),
  },
  {
    text: "공다 무효",
    valueEng: "Not(.*Weaken)",
    value: "영향을 받지(.*공다[^내성])",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWeaken}
        placeholder="공다 무효"
        alt="공다 무효"
      />
    ),
  },
  {
    text: "밀치기 내성",
    valueEng: "Not(.*Knockback)",
    value: "영향을 받지(.*밀치기)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistKnockback}
        placeholder="밀치기 내성"
        alt="밀치기 내성"
      />
    ),
  },
  {
    text: "파동 무효",
    valueEng: "Not(.*Wave)",
    value: "영향을 받지(.*파동)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={UnharmedWaves}
        placeholder="파동 무효"
        alt="파동 무효"
      />
    ),
  },
  {
    text: "저주 무효",
    valueEng: "Not(.*Curse)",
    value: "영향을 받지(.*저주)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistCurse}
        placeholder="저주 무효"
        alt="저주 무효"
      />
    ),
  },
  {
    text: "워프 무효",
    valueEng: "Not(.*Warp)",
    value: "영향을 받지(.*워프)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWarp}
        placeholder="워프 무효"
        alt="워프 무효"
      />
    ),
  },
  {
    text: "베리어 브레이커",
    valueEng: "Barrier Breaker",
    value: "베리어 브레이커",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BarrierBreaker}
        placeholder="베리어 브레이커"
        alt="베리어 브레이커"
      />
    ),
  },
  {
    text: "공격 무효",
    valueEng: "Dodge",
    value: "공격 무효",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Dodge}
        placeholder="공격 무효"
        alt="공격 무효"
      />
    ),
  },
  {
    text: "저주",
    valueEng: "to curse",
    value: "(?!.*영향을 받지 않음u2:.*저주)^.*저주",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Curse}
        placeholder="저주"
        alt="저주"
      />
    ),
  },
  {
    text: "열파 공격",
    valueEng: "Surge Attacks",
    value: "u1일반 능력u2:.[^\n]*?\\b열파 공격\\b",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SurgeAttacks}
        placeholder="열파 공격"
        alt="열파 공격"
      />
    ),
  },
  {
    text: "혼신의 일격",
    valueEng: "Savage Blow",
    value: "혼신의 일격",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SavageBlow}
        placeholder="혼신의 일격"
        alt="혼신의 일격"
      />
    ),
  },
  {
    text: "소파동",
    valueEng: "Mini-Wave",
    value: "소파동",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={MiniWave}
        placeholder="소파동"
        alt="소파동"
      />
    ),
  },
  {
    text: "사도 킬러",
    valueEng: "Eva Angel Killer",
    value: "사도 킬러",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ApostleKiller}
        placeholder="사도 킬러"
        alt="사도 킬러"
      />
    ),
  },
  {
    text: "열파 공격 무효",
    valueEng: "Not(.*Surge)",
    value: "영향을 받지(.*열파)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={EvadeSurge}
        placeholder="열파 공격"
        alt="열파 공격"
      />
    ),
  },
  {
    text: "쉴드 브레이커",
    valueEng: "Shield Piercing",
    value: "쉴드 브레이커",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ShieldPiercing}
        placeholder="쉴드 브레이커"
        alt="쉴드 브레이커"
      />
    ),
  },
  {
    text: "초생명체 특효",
    valueEng: "Colossus Slayer",
    value: "초생명체 특효",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ColossusSlayer}
        placeholder="초생명체 특효"
        alt="초생명체 특효"
      />
    ),
  },
  {
    text: "초수 특효",
    valueEng: "Behemoth Slayer",
    value: "초수 특효",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BehemothSlayer}
        placeholder="초수 특효"
        alt="초수 특효"
      />
    ),
  },
];

export default abilitylist;



// WEBPACK FOOTER //
// ./src/components-kr/utilities/abilitylist.js